import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { SubscriptionComponent } from '@liebherr/old-sage-ui';
import * as userSelectors from '../../../users/users.selectors';
import { AppState } from '../../../app.models';

@Component({
    selector: 'liebherr-language-dialog',
    templateUrl: 'language-dialog.component.html',
    styleUrls: ['language-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageDialogComponent extends SubscriptionComponent {
    langCtrl = this.fb.control(undefined, Validators.required);

    languages = ['de', 'en'];

    language$ = this.store.select(userSelectors.selectLanguage);

    constructor(public dialogRef: MatDialogRef<LanguageDialogComponent>, private fb: UntypedFormBuilder, private store: Store<AppState>) {
        super();
        this.sub.add(
            this.language$.subscribe((lang) => {
                this.langCtrl.setValue(lang);
            })
        );
    }

    onCancel() {
        this.dialogRef.close();
        this.langCtrl.reset();
    }
    onSubmit() {
        if (this.langCtrl.valid && this.langCtrl.dirty) {
            this.dialogRef.close(this.langCtrl.value);
            this.langCtrl.reset();
        }
    }
}
